module.exports = "<ng-container *ngIf=\"item && item.data.length > 0\">\n    <div class=\"container-fluid content-list\">\n        <ng-container *ngFor=\"let row of item.data; index as i\">\n            <content [item]=\"row\" [direction]=\"i % 2 === 0 ? 'right':'left'\" class=\"clickable item\" *ngIf=\"(row|meta).obj_type === 'Link'\" ></content>\n        </ng-container>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/content-list/content-list.template.html
// module id = 795
// module chunks = 2